import { render, staticRenderFns } from "./NuovaSpedizione.vue?vue&type=template&id=4feef8da&scoped=true"
import script from "./NuovaSpedizione.vue?vue&type=script&lang=ts"
export * from "./NuovaSpedizione.vue?vue&type=script&lang=ts"
import style0 from "./NuovaSpedizione.vue?vue&type=style&index=0&id=4feef8da&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4feef8da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4feef8da')) {
      api.createRecord('4feef8da', component.options)
    } else {
      api.reload('4feef8da', component.options)
    }
    module.hot.accept("./NuovaSpedizione.vue?vue&type=template&id=4feef8da&scoped=true", function () {
      api.rerender('4feef8da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/NuovaSpedizione.vue"
export default component.exports